const colors = {
    white: { 'background-color': "#ffffff", 'color': '#1D1D1F' },
    blue: { 'background-color': "#0044FF", 'color': '#ffffff' },
    black: { 'background-color': "#1D1D1F", 'color': '#ffffff' },
    gray: { 'background-color': "#F1F1F3", 'color': '#1D1D1F' },
    darkgray: { 'background-color': "#6F6F71", 'color': '#ffffff' },
    offwhite: { 'background-color': "#FBFBFB", 'color': '#1D1D1F' },
    lightblue: { 'background-color': "#24ACFF", 'color': '#1D1D1F' },
    rose: { 'background-color': "#F73558", 'color': '#1D1D1F' },
    yellow: { 'background-color': "#F8CE05", 'color': '#1D1D1F' },
};


window.findColor = function (color) {
    if (colors[color]) {
        return colors[color];
    }
    return null;
}
window.colorToRGBA = function (color) {
    return `rgba(${color.red}, ${color.green}, ${color.blue}, 1)`;
}
window.colorToObject = function (color) {
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(color)) {
        let c = color.substring(1).split('');
        if (c.length == 3) {
            c = [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c = '0x' + c.join('');
        return {
            alpha: 0xFF,
            blue: c & 255,
            green: (c >> 8) & 255,
            red: (c >> 16) & 255,
        }
    }
    return {
        alpha: 0xFF,
        blue: 0xFF,
        green: 0xFF,
        red: 0xFF,
    }
}
window.edge = function (c1, c2, a) {
    if (a > 1) a = 1;
    if (a < 0) a = 0;
    return (c1 * a) + (c2 * (1 - a));
}
window.colorEdge = function (c1, c2, a) {
    return window.colorToRGBA({
        alpha: window.edge(c1.alpha, c2.alpha, a),
        blue: window.edge(c1.blue, c2.blue, a),
        green: window.edge(c1.green, c2.green, a),
        red: window.edge(c1.red, c2.red, a),
    })
}

window.colorGradient = function (color1, color2, a) {
    return window.colorEdge(window.colorToObject(color1), window.colorToObject(color2), a)
}

// =========================

// Set a cookie with a specified value and expiration
window.setCookie = function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + value + expires + "; path=/";
}

// Retrieve the value of the cookie
window.getCookie = function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

// ========================= 

window.findSection = function (section, old_section) {
    if (!section) { return old_section; }
    let rect = section.getBoundingClientRect();
    let h = rect.top + rect.height;
    if (rect.top < innerHeight && h > 0) {
        return section;
    }
    return old_section;
}
window.searchSection = function () {
    let sections = document.querySelectorAll('section');
    if (sections) {
        for (let index = 0; index < sections.length; index++) {
            const section = window.findSection(sections[index]);
            if (section) {
                return section;
            }
        }
    }
    return null;
}
let thefirst = false;
function tabClick(tab, button, tabcontent, skipscroll) {
    if (tab.tabclick) { tab.tabclick(); }
    if (button.hasAttribute('data-scroll-to')) {
        if (innerWidth < 767) {
            if (thefirst || location.hash != "#noscroll") {
                let tab_scroll = tab.getBoundingClientRect();
                let y = tab_scroll.top + scrollY + 147;
                $("html, body").animate({ scrollTop: y });
            }
        }
    }
    button.classList.add('active');
    if (tabcontent) {
        tabcontent.classList.add('active');
    }
    if (tab.hasAttribute('data-scroll') && thefirst && !skipscroll) {
        let tabcontent_scroll = tabcontent.getBoundingClientRect();
        let y = tabcontent_scroll.top + scrollY - 147;
        $("html, body").animate({ scrollTop: y });
    }
    tab.tabclick = function () {
        button.classList.remove('active')
        if (tabcontent) {
            tabcontent.classList.remove('active')
        }
    }
    thefirst = true;
}
window.tabCallback = function (tab) {
    let tabbuttons = tab.querySelectorAll('.tab-buttons .a-button');
    let tabcontents = tab.querySelectorAll('.tab-content .tab-content-item');

    if (tabbuttons && tabbuttons.length && tabcontents && tabcontents.length) {
        tabClick(tab, tabbuttons[0], tabcontents[0]);
        tabbuttons.forEach((button, index) => {
            button.addEventListener('click', function () {
                tabClick(tab, this, tabcontents[index]);
            })
        })
    }

}

window.tabClick = tabClick;


// WEBPACK FOOTER //
// ./scripts/functions.js